export interface AIHubModelPrice {
  provider: string
  model: string
  input: number
  output: number
}

export const AI_HUB_MODEL_PRICING_UPDATED_AT = '2026-07-16'

// OpenRouter snapshot from https://openrouter.ai/api/v1/models.
// Prices are converted from per-token prompt/completion rates to USD per 1M tokens.
export const AI_HUB_MODEL_PRICING: AIHubModelPrice[] = [
  { provider: 'OpenAI', model: 'openai/gpt-5.6-luna', input: 1, output: 6 },
  { provider: 'OpenAI', model: 'openai/gpt-5.6-terra', input: 2.5, output: 15 },
  { provider: 'OpenAI', model: 'openai/gpt-5.6-sol', input: 5, output: 30 },
  { provider: 'OpenAI', model: 'openai/gpt-5.5', input: 5, output: 30 },
  { provider: 'OpenAI', model: 'openai/gpt-5.5-pro', input: 30, output: 180 },
  { provider: 'OpenAI', model: 'openai/gpt-5.4', input: 2.5, output: 15 },
  { provider: 'OpenAI', model: 'openai/gpt-5.4-mini', input: 0.75, output: 4.5 },
  { provider: 'OpenAI', model: 'openai/gpt-5.4-nano', input: 0.2, output: 1.25 },
  { provider: 'OpenAI', model: 'openai/gpt-oss-120b', input: 0.037, output: 0.17 },
  { provider: 'OpenAI', model: 'openai/gpt-oss-20b', input: 0.03, output: 0.13 },

  { provider: 'Anthropic', model: 'anthropic/claude-sonnet-5', input: 2, output: 10 },
  { provider: 'Anthropic', model: 'anthropic/claude-fable-5', input: 10, output: 50 },
  { provider: 'Anthropic', model: 'anthropic/claude-opus-4.8', input: 5, output: 25 },
  { provider: 'Anthropic', model: 'anthropic/claude-opus-4.8-fast', input: 10, output: 50 },
  { provider: 'Anthropic', model: 'anthropic/claude-sonnet-4.6', input: 3, output: 15 },
  { provider: 'Anthropic', model: 'anthropic/claude-haiku-4.5', input: 1, output: 5 },
  { provider: 'Anthropic', model: 'anthropic/claude-3-haiku', input: 0.25, output: 1.25 },

  { provider: 'Google', model: 'google/gemini-3.5-flash', input: 1.5, output: 9 },
  { provider: 'Google', model: 'google/gemini-3.1-pro-preview', input: 2, output: 12 },
  { provider: 'Google', model: 'google/gemini-3.1-flash-lite', input: 0.25, output: 1.5 },
  { provider: 'Google', model: 'google/gemini-3-flash-preview', input: 0.5, output: 3 },
  { provider: 'Google', model: 'google/gemini-2.5-pro', input: 1.25, output: 10 },
  { provider: 'Google', model: 'google/gemini-2.5-flash', input: 0.3, output: 2.5 },
  { provider: 'Google', model: 'google/gemini-2.5-flash-lite', input: 0.1, output: 0.4 },
  { provider: 'Google', model: 'google/gemma-4-31b-it', input: 0.22, output: 0.55 },

  { provider: 'xAI', model: 'x-ai/grok-4.5', input: 2, output: 6 },
  { provider: 'xAI', model: 'x-ai/grok-build-0.1', input: 1, output: 2 },
  { provider: 'xAI', model: 'x-ai/grok-4.3', input: 1.25, output: 2.5 },
  { provider: 'xAI', model: 'x-ai/grok-4.20', input: 1.25, output: 2.5 },
  { provider: 'xAI', model: 'x-ai/grok-4.20-multi-agent', input: 1.25, output: 2.5 },

  { provider: 'Meta', model: 'meta-llama/llama-4-maverick', input: 0.2, output: 0.8 },
  { provider: 'Meta', model: 'meta-llama/llama-4-scout', input: 0.1, output: 0.3 },
  { provider: 'Meta', model: 'meta-llama/llama-3.3-70b-instruct', input: 0.13, output: 0.4 },
  { provider: 'Meta', model: 'meta-llama/llama-3.1-70b-instruct', input: 0.4, output: 0.4 },
  { provider: 'Meta', model: 'meta-llama/llama-3.1-8b-instruct', input: 0.05, output: 0.08 },

  { provider: 'DeepSeek', model: 'deepseek/deepseek-v4-pro', input: 0.435, output: 0.87 },
  { provider: 'DeepSeek', model: 'deepseek/deepseek-v4-flash', input: 0.098, output: 0.196 },
  { provider: 'DeepSeek', model: 'deepseek/deepseek-v3.2', input: 0.269, output: 0.4 },
  { provider: 'DeepSeek', model: 'deepseek/deepseek-r1-0528', input: 0.5, output: 2.15 },
  { provider: 'DeepSeek', model: 'deepseek/deepseek-r1', input: 0.7, output: 2.5 },
  { provider: 'DeepSeek', model: 'deepseek/deepseek-chat', input: 0.2002, output: 0.8001 },

  { provider: 'Mistral', model: 'mistralai/mistral-medium-3-5', input: 1.5, output: 7.5 },
  { provider: 'Mistral', model: 'mistralai/mistral-small-2603', input: 0.15, output: 0.6 },
  { provider: 'Mistral', model: 'mistralai/mistral-large-2512', input: 0.5, output: 1.5 },
  { provider: 'Mistral', model: 'mistralai/devstral-2512', input: 0.4, output: 2 },
  { provider: 'Mistral', model: 'mistralai/codestral-2508', input: 0.3, output: 0.9 },
  { provider: 'Mistral', model: 'mistralai/mistral-nemo', input: 0.02, output: 0.04 },

  { provider: 'Qwen', model: 'qwen/qwen3.7-max', input: 1.475, output: 4.425 },
  { provider: 'Qwen', model: 'qwen/qwen3.7-plus', input: 0.32, output: 1.28 },
  { provider: 'Qwen', model: 'qwen/qwen3.6-flash', input: 0.1875, output: 1.125 },
  { provider: 'Qwen', model: 'qwen/qwen3-coder-plus', input: 0.65, output: 3.25 },
  { provider: 'Qwen', model: 'qwen/qwen3-coder-flash', input: 0.195, output: 0.975 },
  { provider: 'Qwen', model: 'qwen/qwen3-coder', input: 0.3, output: 1 },

  { provider: 'MoonshotAI', model: 'moonshotai/kimi-k2.7-code', input: 0.719, output: 3.49 },
  { provider: 'MoonshotAI', model: 'moonshotai/kimi-k2.6', input: 0.95, output: 4 },
  { provider: 'MoonshotAI', model: 'moonshotai/kimi-k2-thinking', input: 0.6, output: 2.5 },
  { provider: 'MoonshotAI', model: 'moonshotai/kimi-k2', input: 0.57, output: 2.3 },

  { provider: 'Perplexity', model: 'perplexity/sonar-pro-search', input: 3, output: 15 },
  { provider: 'Perplexity', model: 'perplexity/sonar-pro', input: 3, output: 15 },
  { provider: 'Perplexity', model: 'perplexity/sonar-reasoning-pro', input: 2, output: 8 },
  { provider: 'Perplexity', model: 'perplexity/sonar', input: 1, output: 1 },

  { provider: 'Z.ai', model: 'z-ai/glm-5.2', input: 0.959, output: 3.014 },
  { provider: 'Z.ai', model: 'z-ai/glm-5.1', input: 0.966, output: 3.036 },
  { provider: 'Z.ai', model: 'z-ai/glm-5', input: 0.95, output: 3.15 },
  { provider: 'Z.ai', model: 'z-ai/glm-4.7-flash', input: 0.06, output: 0.4 },

  { provider: 'Cohere', model: 'cohere/command-a', input: 2.5, output: 10 },
  { provider: 'Cohere', model: 'cohere/command-r-plus-08-2024', input: 2.5, output: 10 },
  { provider: 'Cohere', model: 'cohere/command-r-08-2024', input: 0.15, output: 0.6 },
  { provider: 'Cohere', model: 'cohere/command-r7b-12-2024', input: 0.0375, output: 0.15 },
]
